<template>
  <div>
    <span class="name">按省份选择:</span>
    <DropDown
      :list="provinceList"
      title="省份"
      :value="province"
      :showWrapperActive="provinceActive"
      @change_active="changeProvinceActive"
      @change="changeProvince"
      className="province"
    />
    <DropDown
      :list="cityList"
      title="城市"
      :value="city"
      :showWrapperActive="cityActive"
      @change_active="changeCityActive"
      @change="changeCity"
      :disabled="cityDisabled"
      className="city"
    />
    <span>直接搜索：</span>
    <el-select
      v-model="searchWord"
      filterable
      remote
      reserve-keyword
      placeholder="请输入城市中文或拼音"
      :remote-method="remoteMethod"
      :loading="loading"
    >
      <el-option
        v-for="item in searchList"
        :key="item"
        :label="item"
        :value="item"
      ></el-option>
    </el-select>
  </div>
</template>
<script>
import DropDown from "./DropDown.vue";
import api from "@/api/index.js";
export default {
  components: {
    DropDown,
  },
  data() {
    return {
      provinceList: [], //省份列表传值给封装的下拉框菜单组件
      province: "省份",
      cityList: [], // 城市列表
      city: "城市",
      provinceActive: false, //是否选中省份
      cityActive: false, //是否选中城市
      searchList: [
        "北京",
        "上海",
        "广州",
        "深圳",
        "杭州",
        "武汉",
        "成都",
        "西安",
      ],
      searchWord: "",
      loading: false,
      cityDisabled: true,
    };
  },
  created() {
    api.getProvinceList().then((res) => {
      this.provinceList = res.data.data.map((item) => {
        item.name = item.provinceName;
        return item;
      });
      // console.log(this.provinceList);
    });
  },
  methods: {
    changeProvinceActive(flag) {
      this.provinceActive = flag;
      if (flag) {
        this.cityActive = false;
      }
    },
    changeCityActive(flag) {
      this.cityActive = flag;
      if (flag) {
        this.provinceActive = false;
      }
    },
    changeProvince(item) {
      this.province = item.name;
      this.cityDisabled = false;
      this.cityList = item.cityInfoList; //改变身份时获取对应城市
    },
    changeCity(item) {
      this.city = item.name;
      this.$store.dispatch("setPosition", item);
      this.$router.push({ name: "index" });
    },
    remoteMethod(val) {
      //远程搜索
      // 请求后端接口
      console.log(document.cookie, localStorage);
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/css/changecity/iselect.scss";
</style>
